/*
* Association inventory view for authenticated users
*/
import '@progress/kendo-ui';
import './detail-form/detail-form.css';

import { filterBy } from '@progress/kendo-data-query';
import { Grid } from '@progress/kendo-grid-react-wrapper';
import * as _ from 'lodash';
import * as React from 'react';
import { Alert, Button, ButtonToolbar, DropdownButton, MenuItem, Modal, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import Select from 'react-select';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import { AssociationDetailsCopyAddress } from '../association/components/association-details-copy-address';
import Auth from '../auth/auth';
import * as AppComp from '../common/app-component-base';
import { AppDataConstants } from '../common/app-data-constants';
import * as AppUtilities from '../common/apputilities';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { FormUtilities } from '../common/formutilities';
import { GridUtilities } from '../common/grid/gridutilities';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as LK from '../config/apilookupkeys';
import * as ReduxQueries from '../queries';
import * as DetailFormCommon from './detail-form/common';

export const ItemBulkUpdateOperations = {
    SetItemsComplete: 'set-items-completed',
    SetItemsIncomplete: 'set-items-incomplete',
    SetItemsReviewed: 'set-items-reviewed',
    SetItemsNeedReview: 'set-items-need-review',
    SetItemsModifyAvgCost: 'set-items-modify-avg-cost',
};

export const ItemBulkUpdateFields = {
    InventoryComplete: 'complete',
    InventoryReviewed: 'reviewed',
    InventoryModified: 'modified',
};

export interface IAssociationInventoryProps extends AppComp.IAppComponentProps {
    association: any;
    associationId: number;
    currentOrder: any;
    inventory: any;
    lookups?: any;
    filterBySubgroup?: any;
    updateAssociationInventoryItems?: any;
    deleteAssociationInventoryItems?: any;
    newUserInventoryTemplate?: any;
    applyUserInventoryTemplate?: any;
    userInventoryTemplates?: any;
}

export interface IAssociationInventoryState extends AppComp.IAppComponentState {
    avgCostAdjustmentValue: number;
    bulkUpdateItemsOperation: string;
    bulkUpdateItemsValue: any;
    filterAssociation?: any;
    formChanges?: any;
    selectedFilters: any;
    selectedKeys?: any;
    showModalAddSubgroup: boolean;
    showModalAddInventoryTemplate?: boolean;
    showModalApplyInventoryTemplate?: boolean;
    showModalBulkUpdateItems: boolean;
    showModalDeleteItems: boolean;
    showModalDeleteSubgroup: boolean;
    showModalDuplicateSubgroup: boolean;
    showModalMoveItems: boolean;
    showModalPicturesQuestionsResetItems: boolean;
    showModalRenameSubgroup: boolean;
    showModalSaveChanges: boolean;
    skipAssociation?: any;
}

export const LinkButton = ({ className, linkTo, children, ...props }) => {
    return (
        <Link className={`btn btn-sm ${className}`} to={linkTo} {...props}>{...children}</Link>
    );
};

export const AssocNotes = ({ assocNotes, onClickDelete, onClickSave, deleteButtonVisible = true, saveButtonVisible = false, ...rest }) => {
    if (!_.size(assocNotes)) { return (<div />); }

    let result = _.map(assocNotes, (o, i) => {
        return (
            <DetailFormCommon.InventoryNoteRow key={`inventory-note-row-assoc-notes-${i}`}>
                <DetailFormCommon.InventoryNote
                    authorText={`${Formatters.getStr(o, 'author.firstName')} ${Formatters.getStr(o, 'author.lastName')}`}
                    dateText={Formatters.formatDateLongDate(_.get(o, 'created', new Date()))}
                    onClickDelete={(e) => { onClickDelete(e); }}
                    onClickSave={(e) => { onClickSave(e); }}
                    deleteButtonVisible={deleteButtonVisible}
                    saveButtonVisible={saveButtonVisible}
                >
                    <div>{Formatters.getStr(o, 'notes')}</div>
                </DetailFormCommon.InventoryNote>
            </DetailFormCommon.InventoryNoteRow>
        );
    });

    return (
        <div>
            {result}
        </div>
    );
};

class AssociationInventory extends AppComp.AppComponent<any, IAssociationInventoryState> {
    public originalFormDataCache = {};
    public readonly virtualizedDropdownPageSize: number = 20;
    public kendoGridWidgetRef: any;

    public gridOptions = GridUtilities.kendoGridOptions(
        [
            GridUtilities.kendoGridColumnDefinition('', '', 30, 100, undefined, { selectable: true }),
            GridUtilities.kendoGridColumnDefinition('componentId', this.appTextGridColumnHeader('id'), 50, 110),
            GridUtilities.kendoGridColumnDefinition('componentName', this.appTextGridColumnHeader('component'), 220, 120),
            GridUtilities.kendoGridColumnDefinition('categoryName', this.appTextGridColumnHeader('category'), 150, 130),
            GridUtilities.kendoGridColumnDefinition('quantity', this.appTextGridColumnHeader('qty'), 150, 140),
            GridUtilities.kendoGridColumnDefinition(
                'usefulLife',
                this.appTextGridColumnHeader('ul'),
                50,
                150,
                undefined,
                undefined,
                'usefulLife_sort'
            ),
            GridUtilities.kendoGridColumnDefinition(
                'remainingUsefulLife',
                this.appTextGridColumnHeader('rl'),
                50,
                160,
                undefined,
                undefined,
                'remainingUsefulLife_sort'
            ),
            GridUtilities.kendoGridColumnDefinition(
                'avgCost',
                this.appTextGridColumnHeader('avg-cost'),
                100,
                170,
                undefined,
                {
                    format: '{0:c}',
                },
                'avgCost_sort'
            ),
            GridUtilities.kendoGridColumnDefinition('complete_yesNo', this.appTextGridColumnHeader('complete'), 70, 180),
            GridUtilities.kendoGridColumnDefinition('reviewed_yesNo', this.appTextGridColumnHeader('reviewed'), 70, 190),
            GridUtilities.kendoGridColumnDefinition('viewInventoryDetailLink', ' ', 100, 200, GridUtilities.kendoGridLinkColumnTemplate(
                'viewInventoryDetailLink', 'viewInventoryDetailLinkHref', this.appText('view-inventory-detail-link-title')
            )),
        ],
        this.appText('no-results'),
        {
            toolbar: ['excel'],
            excel: {
                allPages: true,
            },
            persistSelection: true,
            widgetRef: (w) => { this.kendoGridWidgetRef = w; },
            change: (e) => {
                const selectedKeys = e.sender.selectedKeyNames();
                this.handleGridRowCheckbox(selectedKeys);
            },
        }
    );

    public DefaultSubgroupFilter = '#DEFAULT#';

    public constructor(props: any) {
        super(props, 'app.association-inventory.');

        const selectedFiltersSubgroup = Formatters.getStr(props, 'filterBySubgroup.subgroup', this.DefaultSubgroupFilter);

        this.state = {
            avgCostAdjustmentValue: 0,
            bulkUpdateItemsOperation: '',
            bulkUpdateItemsValue: '',
            filterAssociation: undefined,
            formChanges: {},
            selectedFilters: {
                subgroup: selectedFiltersSubgroup,
            },
            selectedKeys: [],
            showModalAddSubgroup: false,
            showModalAddInventoryTemplate: false,
            showModalBulkUpdateItems: false,
            showModalDeleteItems: false,
            showModalDeleteSubgroup: false,
            showModalDuplicateSubgroup: false,
            showModalApplyInventoryTemplate: false,
            showModalMoveItems: false,
            showModalPicturesQuestionsResetItems: false,
            showModalRenameSubgroup: false,
            showModalSaveChanges: false,
            skipAssociation: 0,
        };
    }

    public componentDidUpdate() {
        let resetFormData = this.getFormChangesResetRequired();
        const shouldReset = (resetFormData && _.size(this.state.formChanges)) ? true : false;

        if (shouldReset) {
            this.setState({ formChanges: {} });
        }
    }

    // Data transforms
    public extendInventoryData(records: Array<any>, association: any) {
        // Extend grid row data
        if (!records) { return []; }

        const assocInvSubgroups = _.get(association, 'inventorySubgroups', []);
        return records.map(r => {
            let record = _.cloneDeep(r);

            record.categoryName = (record.component) ? Formatters.getStr(record, 'component.category', '') : '';

            const compCustomName = Formatters.getStr(record, 'componentName');
            const compNormalName = Formatters.getStr(record, 'component.name');
            record.componentName = (compCustomName) ? compCustomName : compNormalName;

            record.avgCost = 0;
            record.avgCost_sort = 0.0;
            if (AppUtilities.isNumeric(record.bestCost) && AppUtilities.isNumeric(record.worstCost)) {
                const bestCost = Formatters.getFloat(record, 'bestCost');
                const worstCost = Formatters.getFloat(record, 'worstCost');
                const totalCost = Number(bestCost + worstCost);

                if (totalCost !== 0) {
                    record.avgCost = Number(totalCost / 2.00).toFixed(2);
                    record.avgCost_sort = Number(record.avgCost);
                }
            }
            record.avgCost = Formatters.formatCurrencyIntl(record.avgCost, 2);

            const recSubgroup = Formatters.getStr(record, 'subgroup', '');
            if (_.size(assocInvSubgroups) >= 1) {
                let subgroupDef: any = _.find(assocInvSubgroups, ['groupCode', recSubgroup]);
                record.subgroupLabel = recSubgroup;
                if (Formatters.getStr(subgroupDef, 'title')) {
                    record.subgroupLabel += ` - ${Formatters.getStr(subgroupDef, 'title')}`;
                }
            }

            if (!AppUtilities.isNumeric(record.remainingUsefulLife)) {
                record.remainingUsefulLife = 0;
            }
            record.usefulLife_sort = 0;
            record.remainingUsefulLife_sort = 0;
            if (AppUtilities.isNumeric(record.usefulLife)) { record.usefulLife_sort = parseInt(record.usefulLife, 10); }
            if (AppUtilities.isNumeric(record.remainingUsefulLife)) { record.remainingUsefulLife_sort = parseInt(record.remainingUsefulLife, 10); }

            record.unfunded = false;
            if (
                (Formatters.getStr(record, 'usefulLife') === AppDataConstants.UsefulLifeOptions.NotApplicable)
                || (Formatters.getStr(record, 'usefulLife') === '')) {
                record.unfunded = true;
            }

            record.complete_yesNo = (Formatters.getBool(record, 'complete')) ? this.appText('complete-yes') : this.appText('complete-no'); // 20200121 (record.complete) ? this.appText('complete-yes') : this.appText('complete-no');
            record.reviewed_yesNo = (Formatters.getBool(record, 'reviewed')) ? this.appText('reviewed-yes') : this.appText('reviewed-no'); // 20200121 (record.reviewed) ? this.appText('reviewed-yes') : this.appText('reviewed-no');

            // Reset pictures/questions toggle
            record.clearPicturesQuestions = Formatters.getBool(record, 'clearPicturesQuestions'); // false;
            record.restorePrevPictures = Formatters.getBool(record, 'restorePrevPictures', false); // false;

            // View inventory detail link
            record.viewInventoryDetailLink = '';
            record.viewInventoryDetailLinkHref = '';
            if (record.inventoryId) {
                record.viewInventoryDetailLink = this.appText('view-inventory-detail-link-title');
                record.viewInventoryDetailLinkHref = NavigationLinks.associationInventoryDetail(record.associationId, record.inventoryId);
            }

            return record;
        });
    }

    public extendAssociationData(record: any) {
        if (!record) { return; }

        let result = _.cloneDeep(record);

        if (AppUtilities.isArrayWithLength(record.inventorySubgroups)) {
            result.inventorySubgroups.push({ groupCode: '', title: '', label: this.appText('filter-option-any') });
            result.inventorySubgroups = result.inventorySubgroups.map(c => {
                if (!c.label) {
                    c.label = Formatters.composeInventorySubgroupLabel(c, true); // c.label = `${c.groupCode} - ${c.title}`;
                }

                return c;
            });
        }

        return result;
    }

    public setStateSelectedFilters(filter: any) {
        // Wrapper for this.setState used to mutate state.selectedFilters values
        if (!filter) { return; }

        this.setState({ selectedFilters: Object.assign({}, this.state.selectedFilters, filter) });
    }

    public transformNotes(records: Array<any>) {
        let result = _.stubArray();

        if (!_.size(records)) { return result; }

        result = _.cloneDeep(records);

        result = _.filter(result, (o) => Formatters.getStr(o, 'notes') !== '');

        result = _.orderBy(result, ['created'], ['desc']);

        return result;
    }

    public transformInventoryRUL(records: Array<any>, adjustRULYears: number = 0, hideUnfunded: boolean = false, clearPicturesQuestions: boolean = false, restorePrevPictures: boolean = false) {
        // Extend grid row data
        if (!records) { return []; }

        let result = _.cloneDeep(records);

        if (hideUnfunded) {
            result = _.filter(result, (o) => Formatters.getBool(o, 'unfunded') !== true);
        }

        const selectedKeys = _.get(this.state, 'selectedKeys', []);
        const hasSelectedKeys = (_.size(selectedKeys) > 0) ? true : false;

        const adjustAmount = Number(adjustRULYears);

        result = result.map(r => {
            let record = _.cloneDeep(r);

            const recordId = Formatters.getStr(record, '_id');
            let isSelected = (!hasSelectedKeys || _.includes(selectedKeys, recordId)) ? true : false;

            const prevRUL = Number(Formatters.getInt(record, 'remainingUsefulLife', 0));
            let newRUL = Number(prevRUL + adjustAmount);

            const prevClearPicturesQuestions = Formatters.getBool(record, 'clearPicturesQuestions');
            let newClearPicturesQuestions = (clearPicturesQuestions) ? true : false;

            const prevRestorePrevPictures = Formatters.getBool(record, 'restorePrevPictures');
            let newRestorePrevPictures = (restorePrevPictures) ? true : false;

            let updateRecordRUL = false;
            let updateRecordClearPictures = false;
            let updateRestorePrevPictures = false;
            if (isSelected) {
                if (adjustAmount) {
                    // Do not reduce life of unfunded items (usefulLife = N/A) per Rob email 20200114
                    if ((Formatters.getStr(record, 'usefulLife') === AppDataConstants.UsefulLifeOptions.NotApplicable)
                        || (Formatters.getStr(record, 'usefulLife') === '')
                        || (Formatters.getBool(record, 'unfunded'))) {
                        newRUL = (newRUL < 0) ? 0 : newRUL;
                        updateRecordRUL = true;
                    }

                    if (Formatters.getInt(record, 'remainingUsefulLife', 0) !== newRUL) {
                        updateRecordRUL = true;
                    }

                    if (updateRecordRUL) {
                        _.set(record, 'remainingUsefulLife', newRUL);
                        _.set(record, 'remainingUsefulLife_sort', newRUL);
                        _.set(record, 'remainingUsefulLifeChanged', true);

                        // RF30: Also reset fields picture1, picture2, complete, reviewed
                        _.set(record, 'complete', false);
                        _.set(record, 'complete_yesNo', this.appText('complete-no'));

                        _.set(record, 'reviewed', false);
                        _.set(record, 'reviewed_yesNo', this.appText('reviewed-no'));

                        _.set(record, 'adjustRULYears', adjustAmount);
                    }
                }

                if (prevClearPicturesQuestions !== newClearPicturesQuestions) {
                    updateRecordClearPictures = true;
                    _.set(record, 'clearPicturesQuestions', newClearPicturesQuestions);
                }

                if (prevRestorePrevPictures !== newRestorePrevPictures) {
                    updateRestorePrevPictures = true;
                    _.set(record, 'restorePrevPictures', newRestorePrevPictures);
                }
            }

            return record;
        });

        return result;
    }

    // Handlers
    public handleGridRowCheckbox(keys: any) {
        const nextSelectedKeys = _.cloneDeep(keys);
        const prevSelectedKeys = _.get(this.state, 'selectedKeys', []);
        const same = _.isEqual(nextSelectedKeys, prevSelectedKeys);

        if (!same) { this.setState({ selectedKeys: nextSelectedKeys }); }
    }

    public handleSelectSubgroupFilter(e: any) {
        this.setStateSelectedFilters({ subgroup: e.value });
    }

    public handlePropertyButton(e: any) {
        this.props.navigateTo(NavigationLinks.associationDetail(this.props.associationId));
    }

    public handleReserveStudyButton(e: any) {
        this.props.navigateTo(NavigationLinks.reserveStudy(this.props.associationId));
    }

    public handleClientQuestionsButton(e: any) {
        this.props.navigateTo(NavigationLinks.associationClientQuestionsReportPdf(this.props.associationId));
    }

    public handlePrintReportButton(e: any) {
        this.props.navigateTo(NavigationLinks.associationReportPdf(this.props.associationId));
    }

    public handleMarkItemsCompletedButton(e: any, value: boolean = true) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const inv = _.map(_.get(this.state, 'selectedKeys', []), (o) => {
            return {
                _id: o,
                complete: value,
            };
        });

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { inventory: inv },
        );

        this.props.updateAssociationInventoryItems(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};

                // FORCE RELOAD
                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }

            } else {
                // Error during creation...
            }
        });
    }

    public handleMarkItemsReviewedButton(e: any, value: boolean = true) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const inv = _.map(_.get(this.state, 'selectedKeys', []), (o) => {
            return {
                _id: o,
                reviewed: value,
            };
        });

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { inventory: inv },
        );

        this.props.updateAssociationInventoryItems(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
            } else {
                // Error during creation...
            }
        });
    }

    public handleAddComponentButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        let sg = Formatters.getStr(this.state, 'selectedFilters.subgroup');
        sg = (sg !== '' && sg !== this.DefaultSubgroupFilter) ? sg : '';

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            {
                inventory: { inventoryId: -1, subgroup: sg },
            });

        this.props.newAssociationInventory(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};

                // FORCE RELOAD
                const newAssocId = _.get(response, 'body.associationId');
                const newInvId = _.get(response, 'body.inventoryId');

                this.props.navigateTo(NavigationLinks.associationInventoryDetail(newAssocId, newInvId));
            } else {
                // Error during creation...
            }
        });
    }

    public handleFormSubmit(e: any) {
        // console.log('handleFormSubmit', e);
    }

    public handleFormInputChange(e: any, x: any) {
        let fieldName = '';
        let newValue;

        if (_.get(e, 'target.props.name')) {
            // Kendo form element
            if (_.has(e, 'target.combobox')) {
                // combobox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'target.value');
            } else {
                // assume textbox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'value');
            }
        } else {
            const eventTargetType = _.get(e, 'target.type', '');

            switch (eventTargetType) {
                case 'textarea':
                case 'text':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                case 'virtualized-select':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(x, 'value');
                    break;

                case 'kendo-dropdownlist':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value', '');
                    break;

                case 'delete-button':
                    fieldName = _.get(e, 'target.name', ''); // reportNotesDelete
                    newValue = _.get(e, 'target.value');
                    break;

                case 'kendo-percentage-input':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                default:
                    // console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
                    break;
            }
        }

        // console.log(`handleFormInputChange continuing fieldName ${fieldName} newValue ${newValue}`);

        if (!fieldName) { return; }

        let formChanges = _.cloneDeep(this.state.formChanges);

        let applyChange = false;
        let origVal = _.get(this.originalFormDataCache, fieldName);

        if (_.isArray(origVal)) {
            if (_.includes(origVal, newValue)) {
                applyChange = false;
            } else {
                const formChangesArr = _.get(formChanges, fieldName, []);

                if (_.includes(formChangesArr, newValue)) {
                    applyChange = false;
                } else {
                    formChangesArr.push(newValue);
                    _.set(formChanges, fieldName, _.cloneDeep(formChangesArr));
                    applyChange = true;
                }
            }
        } else {
            if (String(newValue) !== String(origVal)) {
                // New value
                _.set(formChanges, fieldName, newValue);
                applyChange = true;
            } else {
                // Same as orig val
                if (_.has(formChanges, fieldName)) {
                    _.unset(formChanges, fieldName);
                    applyChange = true;
                }
            }
        }

        if (applyChange) {
            this.setState({
                formChanges: formChanges
            });
        }
    }

    public handleSaveButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        let inventoryChanges = _.stubArray();
        const fcAdjustRULYears = Formatters.getInt(this.state, 'formChanges.adjustRULYears');
        const fcAvgCostAdjustmentValue = Formatters.getFloat(this.state, 'formChanges.avgCostAdjustmentValue');
        const fcClearPicturesQuestions = Formatters.getBool(this.state, 'formChanges.clearPicturesQuestions');
        const fcRestorePrevPictures = Formatters.getBool(this.state, 'formChanges.restorePrevPictures');

        if (fcAdjustRULYears !== 0 || fcClearPicturesQuestions || fcRestorePrevPictures) {
            const inv = this.transformInventoryRUL(this.props.inventory, fcAdjustRULYears, false, fcClearPicturesQuestions, fcRestorePrevPictures);
            const invChanged = _.filter(inv, (o) =>
                Formatters.getBool(o, 'remainingUsefulLifeChanged') ||
                Formatters.getBool(o, 'clearPicturesQuestions') ||
                Formatters.getBool(o, 'restorePrevPictures')
            ); // _.get(o, 'remainingUsefulLifeChanged', false) === true);

            if (_.size(invChanged)) {
                inventoryChanges = _.map(invChanged, (o) => _.pick(o, ['_id', 'inventoryId', 'remainingUsefulLife', 'remainingUsefulLifeChanged', 'clearPicturesQuestions', 'restorePrevPictures']));
            }
        }

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { order: _.pick(this.props.currentOrder, ['orderId', '_id']) },
            { inventory: inventoryChanges },
            _.omit(this.state.formChanges, ['newSubgroup', 'clearPicturesQuestions', 'restorePrevPictures'])
        );

        this.props.updateOrder(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};

                this.setState({ selectedKeys: [], formChanges: {}, showModalSaveChanges: false });

                // 20200128: grid.clearSelection() call must be made after setState, or else event timings prevent this.originalFormDataCache update before Render()
                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
            } else {
                // Error during creation...
            }
        });
    }

    // Modal handlers
    public handleShowModalApplyInventoryTemplate(e: any, formData: any) {
        this.setState({ showModalApplyInventoryTemplate: true });
    }

    public handleCloseModalApplyInventoryTemplate() {
        this.setState({ showModalApplyInventoryTemplate: false, formChanges: {} });
    }

    public handleShowModalAddInventoryTemplate(e: any, formData: any) {
        this.setState({ showModalAddInventoryTemplate: true });
    }

    public handleCloseModalAddInventoryTemplate() {
        this.setState({ showModalAddInventoryTemplate: false, formChanges: {} });
    }

    public handleShowModalAddSubgroup(e: any, formData: any) {
        let formChanges = this.state.formChanges;
        _.set(formChanges, 'newSubgroup.groupCode', formData.newSubgroup.groupCode);

        this.setState({ formChanges: formChanges, showModalAddSubgroup: true });
    }

    public handleCloseModalAddSubgroup() {
        this.setState({ showModalAddSubgroup: false });
    }

    public handleShowModalRenameSubgroup(e: any) {
        this.setState({ showModalRenameSubgroup: true });
    }

    public handleCloseModalRenameSubgroup() {
        this.setState({ showModalRenameSubgroup: false });
    }

    public handleShowModalMoveItems(e: any) {
        this.setState({ showModalMoveItems: true });
    }

    public handleCloseModalMoveItems() {
        this.setState({ showModalMoveItems: false, formChanges: { moveItems: { toGroupCode: '' } } });
    }

    public handleShowModalDeleteItems(e: any) {
        this.setState({ showModalDeleteItems: true });
    }

    public handleCloseModalDeleteItems() {
        this.setState({ showModalDeleteItems: false });
    }

    public handleShowModalPicturesQuestionsResetItems(e: any) {
        this.setState({ showModalPicturesQuestionsResetItems: true });
    }

    public handleCloseModalPicturesQuestionsResetItems() {
        this.setState({ showModalPicturesQuestionsResetItems: false });
    }

    public handleShowModalBulkUpdateItems(e: any, o: string = '', v?: any) {
        this.setState({ showModalBulkUpdateItems: true, bulkUpdateItemsOperation: o, bulkUpdateItemsValue: v });
    }

    public handleCloseModalBulkUpdateItems(resetState: boolean = false) {
        if (resetState) {
            this.setState({ showModalBulkUpdateItems: false, bulkUpdateItemsOperation: '', bulkUpdateItemsValue: undefined, formChanges: {} });
        } else {
            this.setState({ showModalBulkUpdateItems: false, bulkUpdateItemsOperation: '', bulkUpdateItemsValue: undefined });
        }
    }

    public handleShowModalDeleteSubgroup(e: any) {
        this.setState({ showModalDeleteSubgroup: true });
    }

    public handleCloseModalDeleteSubgroup() {
        this.setState({ showModalDeleteSubgroup: false });
    }

    public handleAssociationDropdownPageChange(event: any, formData: any) {
        this.setState({
            skipAssociation: event.page.skip
        });
    }

    public handleAssociationDropdownFilterChange(event: any, formData: any) {
        this.setState({
            skipAssociation: 0,
            filterAssociation: event.filter,
        });
    }

    public handleShowModalDuplicateSubgroup(e: any, formData: any) {
        this.setState({ showModalDuplicateSubgroup: true });
    }

    public handleCloseModalDuplicateSubgroup() {
        this.setState({ showModalDuplicateSubgroup: false, formChanges: { duplicateSubgroup: { associationId: undefined, groupCode: '' } } });
    }

    public handleFormAssociationIdInputChange(e: any, x: any) {
        const fieldName = _.get(e, 'target.name', '');
        const newValue = _.get(e, 'target.value', '');

        let prevChanges = this.state.formChanges;
        _.set(prevChanges, 'duplicateSubgroup.associationId', newValue);

        this.setState({
            formChanges: prevChanges
        });
    }

    public handleSaveNewSubgroupButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { subgroup: _.get(this.state.formChanges, 'newSubgroup') },
        );

        const subgroupNewCode = _.get(this.state.formChanges, 'newSubgroup.groupCode');

        this.props.newAssociationSubgroup(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                let formChanges = this.state.formChanges;
                delete formChanges.newSubgroup;

                this.setState({ selectedFilters: { subgroup: _.toUpper(subgroupNewCode) }, formChanges: formChanges, showModalAddSubgroup: false });
            } else {
                // Error during creation...
            }
        });
    }

    public handleRenameSubgroupButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { subgroup: _.get(this.state.formChanges, 'updateSubgroup') },
        );

        const subgroupUpdateCode = _.get(this.state.formChanges, 'updateSubgroup.groupCode');
        const subgroupRenameCode = _.get(this.state.formChanges, 'updateSubgroup.newGroupCode');

        this.props.updateAssociationSubgroup(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                let formChanges = this.state.formChanges;
                delete formChanges.updateSubgroup;

                const sg = (subgroupRenameCode) ? subgroupRenameCode : subgroupUpdateCode;

                this.setState({ selectedFilters: { subgroup: _.toUpper(sg) }, formChanges: formChanges, showModalRenameSubgroup: false });
            } else {
                // Error during creation...
            }
        });
    }

    public handleConfirmMoveItemsButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const invMoveToSubgroup = _.get(this.state, 'formChanges.moveItems.toGroupCode', '');
        const inv = _.map(_.get(this.state, 'selectedKeys', []), (o) => {
            return {
                _id: o,
                subgroup: invMoveToSubgroup,
            };
        });

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { subgroup: _.get(this.state, 'formChanges.moveItems') },
            { inventory: inv },
        );

        if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }

        this.props.updateAssociationInventoryItems(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};

                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
                this.setState({ showModalMoveItems: false });
            } else {
                // Error during creation...
            }
        });
    }

    public handleConfirmDeleteItemsButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const inv = _.map(_.get(this.state, 'selectedKeys', []), (o) => {
            return {
                _id: o,
                delete: true,
            };
        });

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { inventory: inv },
        );

        this.props.deleteAssociationInventoryItems(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};

                // FORCE RELOAD

                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
                this.setState({ showModalDeleteItems: false });
            } else {
                // Error during creation...
            }
        });
    }

    public handleConfirmResetPicturesQuestionsItemsButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const inv = _.map(_.get(this.state, 'selectedKeys', []), (o) => {
            return {
                _id: o,
                resetPicturesQuestions: true,
            };
        });

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { inventory: inv },
        );

        this.props.updateAssociationInventoryItems(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
                this.handleCloseModalPicturesQuestionsResetItems();
            } else {
                // Error during creation...
            }
        });
    }

    public handleConfirmBulkUpdateItemsButton(e: any, updateField: string, updateValue: any, updateAmount?: number) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const inv = _.map(_.get(this.state, 'selectedKeys', []), (o) => {
            let result = _.merge(
                {},
                {
                    _id: o,
                    bulkUpdate: true,
                    updateAmount: (updateAmount) ? updateAmount : 0,
                });

            _.set(result, updateField, updateValue);

            return result;
        });

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { inventory: inv },
        );

        this.props.updateAssociationInventoryItems(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
                this.handleCloseModalBulkUpdateItems(true);
            } else {
                // Error during creation...
            }
        });
    }

    public handleAddInventoryTemplateButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { userInventoryTemplate: _.pick(_.get(this.state, 'formChanges.addInventoryTemplate'), ['name', 'description', 'includeCostsCheckbox', 'userObjId']) },
            { selectedKeys: this.state.selectedKeys }
        );

        this.props.newUserInventoryTemplate(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
                this.handleCloseModalAddInventoryTemplate();
            } else {
                // Error during creation...
            }
        });
    }

    public handleApplyInventoryTemplateButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { userInventoryTemplate: _.pick(_.get(this.state, 'formChanges.applyInventoryTemplate'), ['templateObjId']) }
        );

        this.props.applyUserInventoryTemplate(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
                this.handleCloseModalApplyInventoryTemplate();
            } else {
                // Error during creation...
            }
        });
    }

    public handleDuplicateSubgroupButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { subgroup: _.pick(_.get(this.state.formChanges, 'duplicateSubgroup'), ['groupCode', 'associationId']) },
        );

        this.props.duplicateAssociationSubgroup(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                let formChanges = this.state.formChanges;
                delete formChanges.duplicateSubgroup;

                const duplicateToAssocId = Formatters.getInt(changeData, 'subgroup.associationId');
                const duplicateFromAssocId = Formatters.getInt(changeData, 'association.associationId');
                const duplicateToSubgroupCode = Formatters.getStr(response.body, 'newSubgroup.document.groupCode');

                this.setState({
                    selectedFilters: {
                        subgroup: duplicateToSubgroupCode,
                    },
                    skipAssociation: 0,
                    filterAssociation: undefined,
                    formChanges: {},
                    showModalDuplicateSubgroup: false
                });

                if (duplicateToAssocId !== duplicateFromAssocId) {
                    this.props.navigateTo(NavigationLinks.associationInventory(duplicateToAssocId));
                }
            } else {
                // Error during creation...
            }
        });
    }

    public handleDeleteSubgroupButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { subgroup: _.get(this.state.formChanges, 'deleteSubgroup') },
        );

        this.props.deleteAssociationSubgroup(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                let formChanges = this.state.formChanges;
                delete formChanges.deleteSubgroup;

                this.setState({ selectedFilters: { subgroup: this.DefaultSubgroupFilter }, formChanges: formChanges, showModalDeleteSubgroup: false });
            } else {
                // Error during creation...
            }
        });
    }

    // Helpers
    public getNextLetter(usedCodes: Array<string> = []) {
        const used = _.uniq(_.map(usedCodes, (c) => _.toUpper(c)));
        const singleLetters = _.map(_.range(65, 91), (c) => String.fromCharCode(c));
        const doubleLetters = _.map(singleLetters, (c) => c + c);
        const allCodes = _.concat(singleLetters, doubleLetters);
        const unusedCodes = _.difference(allCodes, used);

        return _.first(unusedCodes);
    }

    public buildOptions(lookups: any, key: any, srcValueField: any = 'name', srcTextField: any = 'name') {
        const l = _.get(lookups, key, []);

        if (_.size(l) <= 0) { return []; }

        return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getStr(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'value');
    }

    public buildOptionsIntValue(lookups: any, key: any, srcValueField: any = 'name', srcTextField: any = 'name', prependValue: boolean = false) {
        const l = _.get(lookups, key, []);

        if (_.size(l) <= 0) { return []; }

        if (prependValue) {
            return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getInt(c, srcValueField), text: `${Formatters.getInt(c, srcValueField)} - ${Formatters.getStr(c, srcTextField)}` })), 'value');
        } else {
            return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getInt(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'value');
        }
    }

    public getFormData(assoc: any, currentOrder: any, inventoryTransformed: any, orderStatuses: any, subgroupTemplates: any, userInventoryTemplates: any, lookups: any) {
        const orderStatusOptions = (_.size(orderStatuses)) ?
            orderStatuses.map((c) => _.merge({}, { value: Formatters.getInt(c, 'statusId'), text: Formatters.getStr(c, 'name') }))
            : [];

        const newSubgroupTemplateOptions = (_.size(subgroupTemplates)) ?
            subgroupTemplates.map((c) => _.merge({}, { value: Formatters.getInt(c, 'templateId'), text: Formatters.getStr(c, 'name') }))
            : [];

        const assocInventorySubgroups = _.get(assoc, 'inventorySubgroups', []);
        const assocInvSubgroupsSorted = _.sortBy(assocInventorySubgroups, (inv) => _.isFinite(_.parseInt(inv.groupCode)) ? _.parseInt(inv.groupCode) : inv.groupCode);
        const subgroupsFiltered = _.reject(assocInvSubgroupsSorted, (each) => each.groupCode === '');
        const subgroupOptions = (_.size(subgroupsFiltered) >= 1) ?
            subgroupsFiltered.map((c) => _.merge({}, { value: Formatters.getStr(c, 'groupCode'), text: Formatters.composeInventorySubgroupLabel(c, true) }))
            : [];

        const hasPrevPictures = _.some(inventoryTransformed.map((item) => _.isEmpty(_.get(item, 'pictures')) && !_.isEmpty(_.get(item, 'prevPictures', []))));

        let associationOptions: any = this.buildOptionsIntValue(lookups, LK.LookupKeys.Associations, 'associationId', 'name', true);
        if (this.state.filterAssociation) {
            associationOptions = filterBy(associationOptions, this.state.filterAssociation);
        }

        const { users } = lookups;
        const inventoryTemplateUserOptions = (_.size(users) >= 1) ?
            users.map((c) => _.merge({}, { value: Formatters.getStr(c, '_id'), text: Formatters.composeUsernameLabel(c, true) })) : [];

        const userInventoryTemplateOptions: any = (_.size(userInventoryTemplates) >= 1) ?
            userInventoryTemplates.map((c) => _.merge({}, { value: Formatters.getStr(c, '_id'), text: Formatters.getStr(c, 'name') })) : [];

        const currentOrderContactNotes = _.get(currentOrder, 'contact.notes', []);
        const contactNotes = this.transformNotes(currentOrderContactNotes);

        const auth = new Auth();
        const authUserObjId = auth.getSessionUserObjectId();
        const userObjIdDisabled = (auth.isAdmin()) ? false : true;
        const templateObjIdDisabled = false; // (auth.isAdmin()) ? false : true;

        let result = {
            associationId: Formatters.getInt(assoc, 'associationId'),

            association: assoc,
            assocNotes: this.transformNotes(_.get(assoc, 'notes', [])),

            clientNotes: this.transformNotes(_.get(currentOrder, 'client.notes', [])),

            contactNotes: contactNotes,

            inventory: inventoryTransformed,
            inventorySubgroups: assocInvSubgroupsSorted,

            adjustRULYears: 0,
            clearPicturesQuestions: false,
            restorePrevPictures: false,
            hasPrevPictures: hasPrevPictures,
            componentFilterHideUnfunded: false,

            avgCostAdjustmentValue: 0,

            moveItems: {
                toGroupCode: '',
            },

            newSubgroup: {
                groupCode: '',
                groupCodePlaceholder: '',
                title: '',
                template: '',
                templateOptions: newSubgroupTemplateOptions,
            },

            updateSubgroup: {
                groupCode: '',
                newGroupCode: '',
                title: '',
            },

            deleteSubgroup: {
                groupCode: '',
            },

            duplicateSubgroup: {
                groupCode: '',
                associationId: Formatters.getInt(this.state.formChanges, 'duplicateSubgroup.associationId', -1),
            },

            addInventoryTemplate: {
                groupCode: '',
                name: '',
                description: '',
                includeCostsCheckbox: false,
                userObjId: authUserObjId,
                userObjIdDisabled: userObjIdDisabled,
            },

            applyInventoryTemplate: {
                _id: '',
                templateObjIdDisabled: templateObjIdDisabled,
            },

            options: {
                subgroups: (subgroupOptions) ? subgroupOptions : [],
                associations: (associationOptions) ? associationOptions : [],
                inventoryTemplateUserOptions: (inventoryTemplateUserOptions) ? inventoryTemplateUserOptions : [],
                userInventoryTemplateOptions: (userInventoryTemplateOptions) ? userInventoryTemplateOptions : [],
            },

            currentOrder: currentOrder,

            orderStatusId: _.get(currentOrder, 'status.statusId', 0),
            orderStatuses: orderStatuses,
            orderStatusOptions: orderStatusOptions,
        };

        const usedCodes = (_.size(result.inventorySubgroups)) ? _.uniq(_.map(result.inventorySubgroups, o => o.groupCode)) : ['A'];
        const next = this.getNextLetter(usedCodes);

        _.set(result, 'newSubgroup.groupCodePlaceholder', next);
        _.set(result, 'newSubgroup.groupCode', next);

        let merged = _.merge(result, this.state.formChanges);

        _.set(merged, 'inventory', this.transformInventoryRUL(merged.inventory, merged.adjustRULYears, merged.componentFilterHideUnfunded, merged.clearPicturesQuestions, merged.restorePrevPictures));

        return merged;
    }

    public getFormChangesCount() {
        return _.size(this.state.formChanges);
    }

    public getFormChangesResetRequired() {
        let resetFormData = false;

        // Props values
        const pa = Formatters.getInt(this.props, 'associationId');

        // Cached values
        const ca = Formatters.getInt(this.originalFormDataCache, 'associationId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            resetFormData = (pa !== ca) ? true : false;
        }

        return resetFormData;
    }

    public closeModal() {
        this.setState({ showModalSaveChanges: false });
    }

    public showModal() {
        this.setState({ showModalSaveChanges: true });
    }

    // Renderers
    public renderButtonToolbar = (associationId: any, formData: any, disableReport: boolean = false, disableClientQuestions: boolean = false) => {
        let saveChangesButtonProps = {
            bsStyle: 'default',
            bsSize: 'sm',
            disabled: true,
            title: this.appTextCommon('buttons.no-changes'),
        };

        if (this.getFormChangesCount()) {
            saveChangesButtonProps = {
                bsStyle: 'success',
                bsSize: 'sm',
                disabled: false,
                title: `${this.appTextCommon('buttons.save')} ${Formatters.plural(this.appTextCommon('buttons.change'), this.getFormChangesCount(), false)}`,
            };
        }

        return (
            <div>
                <Well className="well-sm">
                    <Row>
                        <Col xs={12}>
                            <ButtonToolbar>
                                <Button {...saveChangesButtonProps} onClick={e => { this.handleSaveButton(e); }}>
                                    <i className="glyphicon glyphicon-floppy-disk" /> {saveChangesButtonProps.title}
                                </Button>

                                <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handlePropertyButton(e); }}>
                                    <i className="glyphicon glyphicon-eye-open" /> {this.appTextCommon('buttons.view-association')}
                                </Button>

                                { /* <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handlePropertyButton(e); }}>
                                    <i className="glyphicon glyphicon-th-list" /> {this.appText('links.association-details')}
                                    </Button> */ }

                                <Button bsSize="sm" disabled={disableReport} bsStyle="info" onClick={(e) => { this.handleReserveStudyButton(e); }}>
                                    <i className="fa fa-line-chart" /> {this.appText('links.view-reserve-study')}
                                </Button>

                                <Button bsSize="sm" disabled={disableClientQuestions} bsStyle="info" onClick={(e) => { this.handleClientQuestionsButton(e); }}>
                                    { /* fa fa-print */}
                                    <i className="fa fa-comments" /> {this.appText('links.view-client-questions')}
                                </Button>

                                <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handleAddComponentButton(e); }}>
                                    <i className="glyphicon glyphicon-plus" /> {this.appText('add-component')}
                                </Button>

                                <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handleShowModalAddSubgroup(e, formData); }}>
                                    <i className="glyphicon glyphicon-plus" /> {this.appText('add-subgroup')}
                                </Button>

                                <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handleShowModalRenameSubgroup(e); }}>
                                    <i className="glyphicon glyphicon-edit" /> {this.appText('rename-subgroup')}
                                </Button>

                                <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handleShowModalDuplicateSubgroup(e, formData); }}>
                                    <i className="glyphicon glyphicon-copy" /> {this.appText('duplicate-subgroup')}
                                </Button>

                                <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handleShowModalDeleteSubgroup(e); }}>
                                    <i className="glyphicon glyphicon-trash" /> {this.appText('delete-subgroup')}
                                </Button>

                                <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handleShowModalAddInventoryTemplate(e, formData); }}>
                                    <i className="glyphicon glyphicon-plus" /> {this.appText('add-inventory-template')}
                                </Button>

                                <Button bsSize="sm" bsStyle="info" onClick={(e) => { this.handleShowModalApplyInventoryTemplate(e, formData); }}>
                                    <i className="fa fa-magic" /> {this.appText('apply-inventory-template')}
                                </Button>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </Well>
            </div>
        );
    }

    public InventoryComponents = ({ formData, ...rest }) => {
        let result = (<div />);

        if (!formData) { return result; }

        let subgroupFilter = _.get(this.state, 'selectedFilters.subgroup', this.DefaultSubgroupFilter);
        const invTransformedUnsorted = _.get(formData, 'inventory', []);
        const invTransformedSorted = _.sortBy(invTransformedUnsorted, (inv) => _.isFinite(_.parseInt(inv.subgroup)) ? _.parseInt(inv.subgroup) : inv.subgroup);
        const invTransformedPrep = _.map(invTransformedSorted, (each) => (_.isFinite(_.parseInt(each.subgroup)) && _.inRange(_.parseInt(each.subgroup), 1, 10)) ? FormUtilities.padSubgroupLabel(each) : each);
        const invComponentNames = _.map(invTransformedPrep, (item) => ({ name: item.componentName, item: item })).sort((a, b) => {
            return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
        });
        const invTransformed = _.map(invComponentNames, (each) => each.item);
        const invIdsWithDecimals = _.map(invTransformed, (each) => _.set(each, 'componentId', (each.componentDecimal) ? _.toNumber(each.componentId + '.' + each.componentDecimal) : _.toNumber(each.componentId)));
        const invSubgroups = _.get(formData, 'inventorySubgroups', []);
        const subgroupCount = _.size(invSubgroups) - 1;
        const subgroupOptions = FormUtilities.buildSubgroupSelectOptions(invSubgroups, 'groupCode', 'label', 'groupCode');

        // 20190605 RF34 Rob requests that default view is not grouped/filtered by any subgroup
        // if (subgroupFilter === this.DefaultSubgroupFilter && Formatters.getStr(subgroupOptions, '[1].value') !== '') {
        //     subgroupFilter = Formatters.getStr(subgroupOptions, '[1].value');
        // }
        const subgroupFilterRaw = Formatters.getStr(subgroupOptions, '[0].value');
        // if (subgroupFilter === this.DefaultSubgroupFilter && subgroupFilterRaw !== '') { subgroupFilter = subgroupFilterRaw; }
        if (subgroupFilter === this.DefaultSubgroupFilter) { subgroupFilter = subgroupFilterRaw; }

        const shouldFilter = (subgroupFilter && subgroupFilter !== this.DefaultSubgroupFilter && subgroupFilter !== '') ? true : false;

        let filter;
        if (shouldFilter) {
            filter = { field: 'subgroup', operator: 'eq', value: subgroupFilter };
        }

        const dataSourceInventory = new kendo.data.DataSource({
            data: invIdsWithDecimals,
            filter: filter,
            sort: [
                { dir: 'asc', field: 'componentId' },
            ],
            group: [{ field: 'subgroupLabel' }],
            schema: {
                model: {
                    id: '_id',
                }
            }
        });

        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputPropsRoleCheckbox = _.merge({}, defaultInputProps, {
            colLabelXs: 5,
            colInputXs: 7,
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        // Fetch will apply any filters and update .view().length to the correct total
        dataSourceInventory.fetch(); // 20200303 Uncommented to resolve issue of "xx of yy components shown" text to display current number of records shown

        let gridButtonsDisabled = (_.size(_.get(this.state, 'selectedKeys', [])) > 0) ? false : true;

        let gridButtons = (
            <Row>
                <Col xs={4}>
                    <ButtonToolbar>
                        <Button bsSize="xs" disabled={gridButtonsDisabled} bsStyle="info" onClick={e => { this.handleShowModalDeleteItems(e); }}>
                            <i className="fa fa-trash-o" /> {this.appText('links.delete-items')}
                        </Button>

                        <Button bsSize="xs" disabled={gridButtonsDisabled} bsStyle="info" onClick={e => { this.handleShowModalMoveItems(e); }}>
                            <i className="fa fa-share-square-o" /> {this.appText('links.move-items')}
                        </Button>
                    </ButtonToolbar>
                </Col>
                <Col xs={4}>
                    <ButtonToolbar className="association-inventory-components-grid-toolbar">
                        <DropdownButton
                            bsSize="xs"
                            disabled={gridButtonsDisabled}
                            title={(<span><i className="fa fa-check-square-o" /> {this.appTextCommon('buttons.bulk-complete')}</span>)}
                            id="ddb-set-items-completion"
                            bsStyle="info"
                        >
                            <MenuItem
                                eventKey="items-completed"
                                onSelect={(k, e) => { this.handleShowModalBulkUpdateItems(e, ItemBulkUpdateOperations.SetItemsComplete); }}
                            >
                                {this.appText('links.mark-items-complete')}
                            </MenuItem>
                            <MenuItem
                                eventKey="items-incomplete"
                                onSelect={(k, e) => { this.handleShowModalBulkUpdateItems(e, ItemBulkUpdateOperations.SetItemsIncomplete); }}
                            >
                                {this.appText('links.mark-items-incomplete')}
                            </MenuItem>
                        </DropdownButton>

                        <DropdownButton
                            bsSize="xs"
                            disabled={gridButtonsDisabled}
                            title={(<span><i className="fa fa-eye" /> {this.appText('links.set-items-reviewed')}</span>)}
                            id="ddb-set-items-reviewed"
                            bsStyle="info"
                        >
                            <MenuItem
                                eventKey="items-reviewed"
                                onSelect={(k, e) => { this.handleShowModalBulkUpdateItems(e, ItemBulkUpdateOperations.SetItemsReviewed); }}
                            >
                                {this.appText('links.mark-items-reviewed')}
                            </MenuItem>
                            <MenuItem
                                eventKey="items-not-reviewed"
                                onSelect={(k, e) => { this.handleShowModalBulkUpdateItems(e, ItemBulkUpdateOperations.SetItemsNeedReview); }}
                            >
                                {this.appText('links.mark-items-not-reviewed')}
                            </MenuItem>
                        </DropdownButton>

                        { /* <Button bsSize="xs" disabled={gridButtonsDisabled} bsStyle="info" onClick={e => { this.handleShowModalPicturesQuestionsResetItems(e); }}>
                            <i className="glyphicon glyphicon-erase" /> {this.appText('links.mark-items-reset-pictures-questions')}
                        </Button> */ }
                    </ButtonToolbar>
                </Col>
                <Col xs={4}>
                    <ButtonToolbar>
                        <Button bsSize="xs" disabled={gridButtonsDisabled} bsStyle="info" onClick={e => { this.handleShowModalBulkUpdateItems(e, ItemBulkUpdateOperations.SetItemsModifyAvgCost); }}>
                            <i className="fa fa-line-chart" /> {this.appText('links.adjust-avg-costs')}
                        </Button>
                    </ButtonToolbar>
                </Col>
            </Row>
        );

        const textComponentsShown = `${dataSourceInventory.view().length} ${this.appText('of')} ${this.appTextPlural('component', _.size(invTransformed), true, true)} ${this.appText('shown')}`;

        /* console.log(`components shown`, {
            dataSourceInventoryView: dataSourceInventory.view(),
            dataSourceInventory
        }); */

        return (
            <div>
                <Row>
                    <Col xs={5} xl={4}>
                        <div>
                            <Row>
                                <Col xs={12}>
                                    <h5><b>{this.appText('filter-by-subgroup')}</b></h5>
                                </Col>
                            </Row>

                            <Row className="form-group">
                                <Col xs={6}>
                                    <form onSubmit={e => { e.preventDefault(); }}>
                                        <Select
                                            name="subgroup-filter"
                                            clearable={false}
                                            className="inventory-subgroup-filter-select"
                                            value={subgroupFilter}
                                            options={subgroupOptions}
                                            onChange={e => this.handleSelectSubgroupFilter(e)}
                                        />
                                    </form>
                                </Col>

                                <Col xs={6}>
                                    <div>
                                        <span className="small-link-text">{this.appTextPlural('subgroup', subgroupCount, true, true)} {this.appText('defined')}</span>
                                    </div>
                                    <div>
                                        <span className="small-link-text">{textComponentsShown}</span>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>

                    <Col xs={5} xl={4}>
                        <div>
                            <Row>
                                <Col xs={12}>
                                    <h5><b>{this.appText('component-filters')}</b></h5>
                                </Col>
                            </Row>

                            <Row className="form-group">
                                <Col xs={12}>
                                    <KendoWrappers.KendoCheckbox
                                        name="componentFilterHideUnfunded"
                                        label={this.appText('component-filter-hide-unfunded')}
                                        value={formData.componentFilterHideUnfunded}
                                        {...inputPropsRoleCheckbox}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

                {gridButtons}

                <Row>
                    <Col xs={12}>
                        <Grid dataSource={dataSourceInventory} {...this.gridOptions} />
                    </Col>
                </Row>

            </div>
        );
    }

    // {...this.gridOptions} />

    public CurrentOrderSection = ({ formData, ...rest }) => {
        if (!formData) { return (<div />); }

        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const disabled = (
            (Formatters.getInt(formData, 'currentOrder.orderId') === 0) ||
            (Formatters.getInt(formData, 'orderStatusId') === 0)) ? true : false;

        return (
            <div>
                <div>
                    <KendoWrappers.KendoDisabledInputHidden
                        name="_currentOrder.orderId"
                        label={this.appText('current-order')}
                        value={`${Formatters.getStr(formData, 'currentOrder.orderId')}`}
                        {...inputProps}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoDropdownListInput
                        name="orderStatusId"
                        disabled={disabled}
                        readOnly={disabled}
                        label={this.appText('status')}
                        value={formData.orderStatusId}
                        data={formData.orderStatusOptions}
                        textField="text"
                        valueField="value"
                        onChange={(o) => { this.handleFormInputChange({ target: { name: 'orderStatusId', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                        {...inputPropsVirtualizedSelect}
                    />
                </div>
            </div>
        );
    }

    public AdjustRULsSection = ({ formData, ...rest }) => {
        if (!formData) { return (<div />); }

        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        const inputPropsAdjust = _.merge({}, defaultInputProps, {
            colLabelXs: 5,
            colInputXs: 7,
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        const inputPropsRoleCheckbox = _.merge({}, defaultInputProps, {
            colLabelXs: 5,
            colInputXs: 7,
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let saveChangesButtonProps = {
            bsStyle: 'default',
            bsSize: 'xs',
            disabled: true,
            title: this.appTextCommon('buttons.no-changes'),
        };

        if (this.getFormChangesCount()) {
            saveChangesButtonProps = {
                bsStyle: 'success',
                bsSize: 'xs',
                disabled: false,
                title: `${this.appTextCommon('buttons.save')} ${Formatters.plural(this.appTextCommon('buttons.change'), this.getFormChangesCount(), false)}`,
            };
        }

        const restorePrevPictures = (_.get(formData, 'hasPrevPictures', false)) ?
            <div>
                <KendoWrappers.KendoCheckbox
                    name="restorePrevPictures"
                    label={this.appText('restore-prev-pictures')}
                    value={Formatters.getBool(formData, 'restorePrevPictures')}
                    {...inputPropsRoleCheckbox}
                />
            </div>
            :
            <div />;

        const enableRestore = !_.get(formData, 'hasPrevPictures', false);

        return (
            <div>
                <div>
                    <KendoWrappers.KendoNumberInput
                        name="adjustRULYears"
                        label={this.appText('adjust-rul-years')}
                        min={-100}
                        max={100}
                        value={formData.adjustRULYears}
                        {...inputPropsAdjust}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoCheckbox
                        name="clearPicturesQuestions"
                        label={this.appText('clear-pictures-questions')}
                        value={Formatters.getBool(formData, 'clearPicturesQuestions')}
                        {...inputPropsRoleCheckbox}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoCheckbox
                        name="restorePrevPictures"
                        label={this.appText('restore-prev-pictures')}
                        value={Formatters.getBool(formData, 'restorePrevPictures')}
                        disabled={enableRestore}
                        {...inputPropsRoleCheckbox}
                    />
                </div>
                <div className="association-inventory-detail-component-list-manipulation-footer">
                    <ButtonToolbar>
                        <Button {...saveChangesButtonProps} onClick={e => { this.handleSaveButton(e); }}>
                            <i className="glyphicon glyphicon-floppy-disk" /> {saveChangesButtonProps.title}
                        </Button>
                    </ButtonToolbar>
                </div>
            </div>
        );
    }

    public renderAddSubgroupModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const disabled = ((Formatters.getStr(formData, 'newSubgroup.groupCode') === '')
            || (Formatters.getStr(formData, 'newSubgroup.title') === '')) ? true : false;

        return (
            <Modal show={this.state.showModalAddSubgroup} onHide={() => this.handleCloseModalAddSubgroup()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.add-subgroup.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <DetailFormCommon.InventoryDetailFormSection title="">
                            <KendoWrappers.KendoTextInputDebounced
                                name="newSubgroup.groupCode"
                                label={this.appText('new-subgroup-code')}
                                value={formData.newSubgroup.groupCode}
                                minLength={1}
                                maxLength={2}
                                // pattern="[A-Za-z]{1}"
                                placeholder={`Next code: ${formData.newSubgroup.groupCodePlaceholder}`}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoTextInputDebounced
                                name="newSubgroup.title"
                                label={this.appText('new-subgroup-title')}
                                value={formData.newSubgroup.title}
                                minLength={1}
                                {...inputPropsFullWidth}
                            />

                            <DetailFormCommon.InventoryDetailFormSectionSpacing />

                        </DetailFormCommon.InventoryDetailFormSection>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleSaveNewSubgroupButton(e)}>{this.appText('add-subgroup')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalAddSubgroup()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderRenameSubgroupModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const disabled = ((Formatters.getStr(formData, 'updateSubgroup.groupCode') === '')
            || ((Formatters.getStr(formData, 'updateSubgroup.title') === '') && (Formatters.getStr(formData, 'updateSubgroup.newGroupCode') === ''))) ? true : false;

        return (
            <Modal show={this.state.showModalRenameSubgroup} onHide={() => this.handleCloseModalRenameSubgroup()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.rename-subgroup.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <DetailFormCommon.InventoryDetailFormSection title="">
                            <KendoWrappers.KendoDropdownListInput
                                name="updateSubgroup.groupCode"
                                clearable={true}
                                label={this.appText('subgroup')}
                                value={_.get(formData, 'updateSubgroup.groupCode')}
                                data={_.get(formData, 'options.subgroups')}
                                textField="text"
                                valueField="value"
                                onChange={(o) => { this.handleFormInputChange({ target: { name: 'updateSubgroup.groupCode', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                                {...inputPropsVirtualizedSelect}
                            />

                            <KendoWrappers.KendoTextInputDebounced
                                name="updateSubgroup.newGroupCode"
                                label={this.appText('rename-subgroup-code')}
                                value={formData.updateSubgroup.newGroupCode}
                                placeholder={formData.updateSubgroup.groupCode}
                                minLength={1}
                                maxLength={2}
                                {...inputPropsFullWidth}
                            />

                            <KendoWrappers.KendoTextInputDebounced
                                name="updateSubgroup.title"
                                label={this.appText('rename-subgroup-title')}
                                value={formData.updateSubgroup.title}
                                minLength={1}
                                {...inputPropsFullWidth}
                            />
                        </DetailFormCommon.InventoryDetailFormSection>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleRenameSubgroupButton(e)}>{this.appText('rename-subgroup')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalRenameSubgroup()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderMoveItemsModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const disabled = (Formatters.getStr(formData, 'moveItems.toGroupCode') === '') ? true : false;

        return (
            <Modal enforceFocus={false} show={this.state.showModalMoveItems} onHide={() => this.handleCloseModalMoveItems()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.move-items.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <DetailFormCommon.InventoryDetailFormSection title="">
                            <KendoWrappers.KendoDropdownListInput
                                name="moveItems.toGroupCode"
                                clearable={true}
                                label={this.appText('modals.move-items.to-subgroup')}
                                value={_.get(formData, 'moveItems.toGroupCode')}
                                data={_.get(formData, 'options.subgroups')}
                                textField="text"
                                valueField="value"
                                onChange={(o) => { this.handleFormInputChange({ target: { name: 'moveItems.toGroupCode', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                                {...inputPropsVirtualizedSelect}
                            />
                        </DetailFormCommon.InventoryDetailFormSection>
                    </div>
                    <div>
                        Confirm the subgroup you want to move the selected items to.
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleConfirmMoveItemsButton(e)}>{this.appText('links.move-items')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalMoveItems()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderDeleteItemsModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const disabled = false; // (Formatters.getStr(formData, 'deleteSubgroup.groupCode') === '') ? true : false;

        return (
            <Modal enforceFocus={false} show={this.state.showModalDeleteItems} onHide={() => this.handleCloseModalDeleteItems()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.delete-items.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    { /* <div>
                        <DetailFormCommon.InventoryDetailFormSection title="">
                            <KendoWrappers.KendoDropdownListInput
                                name="deleteSubgroup.groupCode"
                                clearable={true}
                                label={this.appText('new-subgroup-code')}
                                value={_.get(formData, 'deleteSubgroup.groupCode')}
                                data={_.get(formData, 'options.subgroups')}
                                textField="text"
                                valueField="value"
                                onChange={(o) => { this.handleFormInputChange({target: { name: 'deleteSubgroup.groupCode', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') }}, o); }}
                                {...inputPropsVirtualizedSelect}
                            />
                        </DetailFormCommon.InventoryDetailFormSection>
                    </div> */ }
                    <div>
                        Warning! This will permanently delete all checked inventory items, along with any linked research. Are you sure you want to continue?
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleConfirmDeleteItemsButton(e)}>{this.appText('links.delete-items')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalDeleteItems()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderDeleteSubgroupModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const disabled = (Formatters.getStr(formData, 'deleteSubgroup.groupCode') === '') ? true : false;

        return (
            <Modal show={this.state.showModalDeleteSubgroup} onHide={() => this.handleCloseModalDeleteSubgroup()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.delete-subgroup.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <DetailFormCommon.InventoryDetailFormSection title="">
                            <KendoWrappers.KendoDropdownListInput
                                name="deleteSubgroup.groupCode"
                                clearable={true}
                                label={this.appText('new-subgroup-code')}
                                value={_.get(formData, 'deleteSubgroup.groupCode')}
                                data={_.get(formData, 'options.subgroups')}
                                textField="text"
                                valueField="value"
                                onChange={(o) => { this.handleFormInputChange({ target: { name: 'deleteSubgroup.groupCode', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                                {...inputPropsVirtualizedSelect}
                            />
                        </DetailFormCommon.InventoryDetailFormSection>
                    </div>
                    <div>
                        Note: any inventory components in this group will be reassigned to subgroup 'A'
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleDeleteSubgroupButton(e)}>{this.appText('delete-subgroup')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalDeleteSubgroup()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderResetItemPicturesQuestionsModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        // const disabled = (Formatters.getStr(formData, 'deleteSubgroup.groupCode') === '') ? true : false;

        return (
            <Modal enforceFocus={false} show={this.state.showModalPicturesQuestionsResetItems} onHide={() => this.handleCloseModalPicturesQuestionsResetItems()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.reset-item-pictures-questions.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        {this.appText('modals.reset-item-pictures-questions.note')}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={(e) => this.handleConfirmResetPicturesQuestionsItemsButton(e)}>{this.appText('modals.reset-item-pictures-questions.reset-items')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalPicturesQuestionsResetItems()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderBulkUpdateItemsModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };
        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const bulkOperation = Formatters.getStr(this.state, 'bulkUpdateItemsOperation');
        if (!bulkOperation) { return (<div />); }

        let opTokenText: string = '';
        let opTokenAdjustmentText = '';
        let opFieldName: string = '';
        let opFieldValue: any;
        let opFieldAmount: number;
        let hasValue: boolean = false;

        switch (bulkOperation) {
            default:
            case ItemBulkUpdateOperations.SetItemsComplete:
                opTokenText = this.appText('modals.bulk-update-items.generic.complete');
                opFieldName = ItemBulkUpdateFields.InventoryComplete;
                opFieldValue = true;
                break;

            case ItemBulkUpdateOperations.SetItemsIncomplete:
                opTokenText = this.appText('modals.bulk-update-items.generic.incomplete');
                opFieldName = ItemBulkUpdateFields.InventoryComplete;
                opFieldValue = false;
                break;

            case ItemBulkUpdateOperations.SetItemsReviewed:
                opTokenText = this.appText('modals.bulk-update-items.generic.reviewed');
                opFieldName = ItemBulkUpdateFields.InventoryReviewed;
                opFieldValue = true;
                break;

            case ItemBulkUpdateOperations.SetItemsNeedReview:
                opTokenText = this.appText('modals.bulk-update-items.generic.needs-review');
                opFieldName = ItemBulkUpdateFields.InventoryReviewed;
                opFieldValue = false;
                break;

            case ItemBulkUpdateOperations.SetItemsModifyAvgCost:
                hasValue = true;
                opTokenText = this.appText('modals.bulk-update-items.generic.modify-avg-cost');
                opTokenText = this.appText('modals.bulk-update-items.generic.modify-avg-cost');
                opFieldName = ItemBulkUpdateFields.InventoryModified;
                opFieldValue = true;
                opFieldAmount = formData.avgCostAdjustmentValue;
                break;
        }

        const modalButtonHandler = (e) => { (hasValue) ? this.handleConfirmBulkUpdateItemsButton(e, opFieldName, opFieldValue, opFieldAmount) : this.handleConfirmBulkUpdateItemsButton(e, opFieldName, opFieldValue); };
        const modalTitle = this.appText('modals.bulk-update-items.generic.title', true, opTokenText);
        const modalNote = (hasValue) ? this.appText('modals.bulk-update-items.generic.note-with-value', true, opTokenText, opTokenAdjustmentText) : this.appText('modals.bulk-update-items.generic.note', true, opTokenText);
        const modalButtonText = this.appText('modals.bulk-update-items.generic.update-items', true, opTokenText);
        const modalValueEntry = (hasValue) ?
            <div><KendoWrappers.KendoPercentageInput
                name="bulk-modify-avg-cost"
                label={this.appText('modals.modify-avg-costs.label')}
                value={formData.avgCostAdjustmentValue}
                step={0.01}
                onChange={(o) => { this.handleFormInputChange({ target: { name: 'avgCostAdjustmentValue', type: 'kendo-percentage-input', value: _.get(o, 'target.value') } }, o); }}
                {...inputPropsVirtualizedSelect} /></div>
            : <div />;

        return (
            <Modal enforceFocus={false} show={this.state.showModalBulkUpdateItems} onHide={() => (formData.avgCostAdjustmentValue !== 0) ? this.handleCloseModalBulkUpdateItems(true) : this.handleCloseModalBulkUpdateItems()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        {modalNote}
                        {modalValueEntry}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={(e) => modalButtonHandler(e)}>{modalButtonText}</Button>
                    <Button bsStyle="danger" onClick={() => (formData.avgCostAdjustmentValue !== 0) ? this.handleCloseModalBulkUpdateItems(true) : this.handleCloseModalBulkUpdateItems()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderDuplicateSubgroupModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const disabled = ((Formatters.getStr(formData, 'duplicateSubgroup.groupCode') === '')
            || (Formatters.getInt(formData, 'duplicateSubgroup.associationId') <= 0)) ? true : false;

        return (
            <Modal enforceFocus={false} show={this.state.showModalDuplicateSubgroup} onHide={() => this.handleCloseModalDuplicateSubgroup()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.duplicate-subgroup.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <form onSubmit={e => { e.preventDefault(); }}>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDropdownListInput
                                    name="duplicateSubgroup.groupCode"
                                    clearable={true}
                                    label={this.appText('modals.duplicate-subgroup.subgroup')}
                                    value={_.get(formData, 'duplicateSubgroup.groupCode')}
                                    data={_.get(formData, 'options.subgroups', [])}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => { this.handleFormInputChange({ target: { name: 'duplicateSubgroup.groupCode', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                                    {...inputPropsVirtualizedSelect}
                                />

                                <KendoWrappers.KendoDropdownListInput
                                    name="duplicateSubgroup.associationId"
                                    clearable={true}
                                    filterable={true}
                                    onFilterChange={(e) => { this.handleAssociationDropdownFilterChange(e, formData); }}
                                    label={this.appText('modals.duplicate-subgroup.association-destination')}
                                    value={_.get(formData, 'duplicateSubgroup.associationId')}
                                    data={_.get(formData, 'options.associations', []).slice(this.state.skipAssociation, this.state.skipAssociation + this.virtualizedDropdownPageSize)}
                                    required={true}
                                    virtual={{
                                        total: _.size(_.get(formData, 'options.associations', [])),
                                        pageSize: this.virtualizedDropdownPageSize,
                                        skip: this.state.skipAssociation,
                                    }}
                                    onPageChange={(e) => { this.handleAssociationDropdownPageChange(e, formData); }}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        this.handleFormAssociationIdInputChange({ target: { name: 'duplicateSubgroup.associationId', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o);
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </form>
                    </div>
                    <div>
                        {this.appText('modals.duplicate-subgroup.note')}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleDuplicateSubgroupButton(e)}>{this.appText('duplicate-subgroup')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalDuplicateSubgroup()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderAddInventoryTemplateModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsCostsCheckbox = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        const disabled = ((Formatters.getStr(formData, 'addInventoryTemplate.userObjId') === '')
            || (Formatters.getStr(formData, 'addInventoryTemplate.name') === '')) ? true : false;

        return (
            <Modal enforceFocus={false} show={this.state.showModalAddInventoryTemplate} onHide={() => this.handleCloseModalAddInventoryTemplate()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.add-template.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <form onSubmit={e => { e.preventDefault(); }}>
                            <DetailFormCommon.InventoryDetailFormSection title="">

                                <KendoWrappers.KendoDropdownListInput
                                    name="addInventoryTemplate.userObjId"
                                    clearable={false}
                                    label={this.appText('modals.add-template.user')}
                                    value={formData.addInventoryTemplate.userObjId}
                                    data={_.get(formData, 'options.inventoryTemplateUserOptions', [])}
                                    textField="text"
                                    disabled={Formatters.getBool(formData, 'addInventoryTemplate.userObjIdDisabled')}
                                    valueField="value"
                                    onChange={(o) => { this.handleFormInputChange({ target: { name: 'addInventoryTemplate.userObjId', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                                    {...inputPropsVirtualizedSelect}
                                />

                                <KendoWrappers.KendoTextInputDebounced
                                    name="addInventoryTemplate.name"
                                    label={this.appText('modals.add-template.name')}
                                    value={formData.addInventoryTemplate.name}
                                    minLength={1}
                                    {...inputPropsFullWidth}
                                />

                                <KendoWrappers.KendoTextInputDebounced
                                    name="addInventoryTemplate.description"
                                    label={this.appText('modals.add-template.description')}
                                    value={formData.addInventoryTemplate.description}
                                    {...inputPropsFullWidth}
                                />

                                <KendoWrappers.KendoCheckbox
                                    name="addInventoryTemplate.includeCostsCheckbox"
                                    label={this.appText('modals.add-template.includeCostsCheckbox')}
                                    value={formData.addInventoryTemplate.includeCostsCheckbox}
                                    {...inputPropsCostsCheckbox}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </form>

                        <div>{this.appText('modals.add-template.note')}</div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleAddInventoryTemplateButton(e)}>{this.appText('modals.add-template.success-button-title')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalAddInventoryTemplate()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderApplyInventoryTemplateModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const disabled = ((Formatters.getStr(formData, 'applyInventoryTemplate.templateObjId') === '')) ? true : false;

        return (
            <Modal enforceFocus={false} show={this.state.showModalApplyInventoryTemplate} onHide={() => this.handleCloseModalApplyInventoryTemplate()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.apply-template.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <form onSubmit={e => { e.preventDefault(); }}>
                            <DetailFormCommon.InventoryDetailFormSection title="">

                                <KendoWrappers.KendoDropdownListInput
                                    name="applyInventoryTemplate.templateObjId"
                                    clearable={false}
                                    label={this.appText('modals.apply-template.name')}
                                    value={formData.applyInventoryTemplate.userObjId}
                                    data={_.get(formData, 'options.userInventoryTemplateOptions', [])}
                                    textField="text"
                                    disabled={Formatters.getBool(formData, 'applyInventoryTemplate.templateObjIdDisabled')}
                                    valueField="value"
                                    onChange={(o) => { this.handleFormInputChange({ target: { name: 'applyInventoryTemplate.templateObjId', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                                    {...inputPropsVirtualizedSelect}
                                />

                            </DetailFormCommon.InventoryDetailFormSection>
                        </form>
                    </div>
                    <div>
                        {this.appText('modals.apply-template.note')}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleApplyInventoryTemplateButton(e)}>{this.appText('modals.apply-template.success-button-title')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalApplyInventoryTemplate()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public render() {
        const { association, associationId, inventory, currentOrder, orderStatuses, inventoryTemplates, lookups, userInventoryTemplates, dfilterBySubgroup, ...rest } = this.props;

        const assoc = this.extendAssociationData(association);
        const inv = this.extendInventoryData(inventory, assoc);
        const order = _.cloneDeep(currentOrder);

        const pageTitle = this.appTextPageTitleAppendString(_.get(assoc, 'name', ''), 'page-title', true);
        let page = (<div />);

        if (Number(_.get(assoc, 'associationId', -1)) === Number(associationId)) {
            const formData = this.getFormData(assoc, order, inv, orderStatuses, inventoryTemplates, userInventoryTemplates, lookups);

            let ofdcReset = false;
            if (this.getFormChangesResetRequired() || !_.size(this.originalFormDataCache)) {
                this.originalFormDataCache = _.cloneDeep(formData);
                ofdcReset = true;
            }

            let assocAddress: Array<string> = [];
            if (assoc.location) {
                if (assoc.location.city) { assocAddress.push(assoc.location.city); }
                if (assoc.location.stateCode) { assocAddress.push(assoc.location.stateCode); }
            }

            let hasComponentsWithNegativeRUL = (_.find(inv, (o) => Formatters.getInt(o, 'remainingUsefulLife_sort') < 0)) ? true : false;
            let warnCompWithNegativeLife = (<div />);
            if (hasComponentsWithNegativeRUL) {
                warnCompWithNegativeLife = (
                    <div className="association-inventory-alert-component-negative-rul">
                        <Alert bsStyle="warning">
                            <h4><i className="fa fa-exclamation-triangle" /> {this.appText('alerts.warn-component-negative-rul.title')}</h4>
                            <p>{this.appText('alerts.warn-component-negative-rul.body')}</p>
                        </Alert>
                    </div>
                );
            }

            page = (
                <div>
                    {this.renderAddSubgroupModal(formData)}
                    {this.renderRenameSubgroupModal(formData)}
                    {this.renderDeleteSubgroupModal(formData)}
                    {this.renderDuplicateSubgroupModal(formData)}
                    {this.renderBulkUpdateItemsModal(formData)}
                    {this.renderAddInventoryTemplateModal(formData)}
                    {this.renderApplyInventoryTemplateModal(formData)}
                    {this.renderMoveItemsModal(formData)}
                    {this.renderDeleteItemsModal(formData)}
                    {this.renderResetItemPicturesQuestionsModal(formData)}
                    {this.renderButtonToolbar(associationId, formData, hasComponentsWithNegativeRUL)}

                    <WhiteBoxPageSection title="">
                        <Row>
                            <Col xs={6} xl={4}>
                                <DetailFormCommon.InventoryDetailFormSection title={this.appText('association-details')}>
                                    <AssociationDetailsCopyAddress association={assoc} />
                                </DetailFormCommon.InventoryDetailFormSection>
                            </Col>

                            <Col xs={6} xl={4}>
                                <DetailFormCommon.InventoryDetailFormSection title={this.appText('current-order-details')}>
                                    <this.CurrentOrderSection formData={formData} />
                                </DetailFormCommon.InventoryDetailFormSection>
                            </Col>

                            <Col xs={6} xl={4}>
                                <DetailFormCommon.InventoryDetailFormSection title={this.appText('reset-component-ruls')}>
                                    <this.AdjustRULsSection formData={formData} />
                                </DetailFormCommon.InventoryDetailFormSection>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12}>
                                <DetailFormCommon.InventoryDetailFormSection title={this.appText('inventory-components')}>
                                    {warnCompWithNegativeLife}
                                    <this.InventoryComponents formData={formData} />
                                </DetailFormCommon.InventoryDetailFormSection>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={4}>
                                <DetailFormCommon.InventoryDetailFormSection title={this.appText('association-notes')}>
                                    <AssocNotes
                                        assocNotes={formData.assocNotes}
                                        onClickDelete={(e) => { console.log(e); }}
                                        onClickSave={(e) => { console.log(e); }}
                                        deleteButtonVisible={false}
                                        saveButtonVisible={false}
                                    />
                                </DetailFormCommon.InventoryDetailFormSection>
                            </Col>

                            <Col xs={12} md={4}>
                                <DetailFormCommon.InventoryDetailFormSection title={this.appText('client-notes')}>
                                    <AssocNotes
                                        assocNotes={formData.clientNotes}
                                        onClickDelete={(e) => { console.log(e); }}
                                        onClickSave={(e) => { console.log(e); }}
                                        deleteButtonVisible={false}
                                        saveButtonVisible={false}
                                    />
                                </DetailFormCommon.InventoryDetailFormSection>
                            </Col>

                            <Col xs={12} md={4}>
                                <DetailFormCommon.InventoryDetailFormSection title={this.appText('contact-notes')}>
                                    <AssocNotes
                                        assocNotes={formData.contactNotes}
                                        onClickDelete={(e) => { console.log(e); }}
                                        onClickSave={(e) => { console.log(e); }}
                                        deleteButtonVisible={false}
                                        saveButtonVisible={false}
                                    />
                                </DetailFormCommon.InventoryDetailFormSection>
                            </Col>
                        </Row>
                    </WhiteBoxPageSection>
                </div>
            );
        }

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrlLookups = () => ApiEndpoints.getLookupsByKeyUrl([
    LK.LookupKeys.Associations,
    LK.LookupKeys.Users,
]);

const getApiUrl = (id) => ApiEndpoints.getAssociationInventoryUrl(id);

const mapPropsToConfigs = (props) => {
    return [
        ReduxQueries.Queries.getAssociationInventoryRequest(
            getApiUrl(_.get(props, 'associationId', 0)),
            ReduxQueries.PropsAccessToken(props),
        ),

        ReduxQueries.Queries.getLookupsByKeyRequest(
            getApiUrlLookups(),
            ReduxQueries.PropsAccessToken(props)
        ),
    ];
};

const mapStateToProps = (state, props) => {
    const associationId = props.match.params.associationId;

    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(associationId), state, props, {
        association: state.entities.associationInventoryAssociation,
        associationId: associationId,
        currentOrder: state.entities.associationInventoryCurrentOrder,
        inventory: state.entities.associationInventoryInventory,
        orderStatuses: state.entities.associationInventoryOrderStatuses,
        inventoryTemplates: state.entities.associationInventoryTemplates,
        filterBySubgroup: state.viewFiltersAssociationInventory,
        userInventoryTemplates: state.entities.associationInventoryUserInventoryTemplates,
    });
};

const mapDispatchToProps = {
    updateOrder: MutateActions.updateOrderMutateAsync,
    newAssociationInventory: MutateActions.newAssociationInventoryMutateAsync,
    newAssociationSubgroup: MutateActions.newAssociationInventorySubgroupMutateAsync,
    updateAssociationSubgroup: MutateActions.updateAssociationInventorySubgroupMutateAsync,
    updateAssociationInventoryItems: MutateActions.updateAssociationInventoryItemsMutateAsync,
    deleteAssociationSubgroup: MutateActions.deleteAssociationInventorySubgroupMutateAsync,
    duplicateAssociationSubgroup: MutateActions.duplicateAssociationInventorySubgroupMutateAsync,
    deleteAssociationInventoryItems: MutateActions.deleteAssociationInventoryItemsMutateAsync,
    newUserInventoryTemplate: MutateActions.newUserInventoryTemplateMutateAsync,
    applyUserInventoryTemplate: MutateActions.applyUserInventoryTemplateMutateAsync,
    navigateTo: (path) => push(path)
};

const AssociationInventoryContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(AssociationInventory);

export default withRouter(AssociationInventoryContainer);



// WEBPACK FOOTER //
// ./src/inventory/index.tsx